/**
 * Profile Code Constants
 * 
 * These constants represent the code values from profile lookup tables.
 * Use these instead of magic numbers throughout the application.
 */

// Profile Worker T4 Type Codes
export const PROFILE_WORKER_T4_TYPE = {
  T4_HOURLY: 1,
  T4_SALARIED: 2,
} as const

// Type definitions for type safety
export type ProfileWorkerT4Type = typeof PROFILE_WORKER_T4_TYPE[keyof typeof PROFILE_WORKER_T4_TYPE] 

export const PROFILE_TYPE = {
  ORGANIZATIONAL: 1,
  INTERNAL: 2,
  T4: 3,
  CANADIAN_INC: 5,
} as const

export type ProfileType = typeof PROFILE_TYPE[keyof typeof PROFILE_TYPE]

export const PROFILE_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  PENDING_CHANGE: 7,
  PENDING_DEACTIVATION: 9,
  TERMINATED: 16
} as const

export type ProfileStatus = typeof PROFILE_STATUS[keyof typeof PROFILE_STATUS]